import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from "react-i18next";

const AuthorisationDeniedWarning: React.FC = () => {
    const { t } = useTranslation('common');
    return <Alert status="error" mb="4">
    <AlertIcon />
    <Box>
      <AlertTitle>{t('common:agentAuthorisationDeniedByApplic')}</AlertTitle>
      <AlertDescription>{'This application has been closed'}</AlertDescription>
    </Box>
  </Alert>;
  };

export default AuthorisationDeniedWarning;
